import { useMemo } from "react";
import { countryCodes } from "./countryCodes";

export const useCountryCodes = () => {
  const countries = useMemo(
    () => [...countryCodes].sort((a, b) => a.name.localeCompare(b.name)),
    []
  );

  return {
    countryCodes: countries,
    loadingCountryCodes: false,
  };
};